import { createDomain } from 'effector';

export const rootDomain = createDomain('root');
